import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Progress from 'core/components/progress/Progress'
import { renderAge } from 'k8s/components/common/entity/helpers'
import SummaryCard from 'k8s/components/common/entity/summary-card'
import { ICustomResourceDefinitionSelector } from 'k8s/components/cluster-administration/custom-resource-definitions/model'
import InfoCard from 'k8s/components/common/entity/info-card'
import { getFieldsForCard } from 'core/components/InfoPanel'
import LabelsAndAnnotationsSection from 'k8s/components/common/entity/labels-and-annotations/LabelsAndAnnotationsSection'
import Grid from 'core/elements/grid/Grid'
import Card from 'core/elements/card/Card'
import { DateAndTime } from 'core/components/listTable/cells/DateCell'

const statusConditionsColumns = [
  { key: 'type', label: 'Type' },
  { key: 'status', label: 'Status' },
  {
    key: 'lastTransitionTime',
    label: 'Last Transition Time',
    CellComponent: DateAndTime,
  },
  { key: 'reason', label: 'Reason' },
  { key: 'message', label: 'Message' },
]

const summaryRows: { key: keyof ICustomResourceDefinitionSelector; label: string }[] = [
  { key: 'group', label: 'Group' },
  { key: 'scope', label: 'Scope' },
  { key: 'clusterName', label: 'Cluster' },
]

const CustomResourceDefinitionsOverview = ({
  customResourceDefinition,
  loading,
  reload,
}: {
  customResourceDefinition: ICustomResourceDefinitionSelector
  loading: boolean
  reload: (refetch: boolean) => void
}) => {
  const classes = useStyles()

  const metadataFields = [
    {
      id: 'age',
      title: 'Created',
      required: true,
      render: renderAge,
    },
  ]

  const metadata = useMemo(() => {
    return getFieldsForCard(metadataFields, customResourceDefinition)
  }, [customResourceDefinition])

  return (
    <Progress loading={loading} renderContentOnMount={false}>
      <div className={classes.container}>
        <div className={classes.column}>
          <SummaryCard<ICustomResourceDefinitionSelector>
            title={customResourceDefinition?.name}
            subtitle="Custom Resource Defintion"
            rows={summaryRows}
            data={customResourceDefinition}
          />
          <InfoCard
            items={metadata}
            title="Properties"
            footer={
              <div className={classes.footer}>
                <LabelsAndAnnotationsSection
                  entity={customResourceDefinition}
                  resourceType="configMap"
                />
              </div>
            }
          />
        </div>
        <div className={classes.column}>
          <Card title={'Status Conditions'} withCustomBody>
            <Grid
              uniqueIdentifier="type"
              data={customResourceDefinition?.status?.conditions ?? []}
              columns={statusConditionsColumns}
              disableToolbar
            />
          </Card>
        </div>
      </div>
    </Progress>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '633px 1fr',
    marginTop: '16px',
    gridGap: '24px',
  },
  column: {
    display: 'grid',
    gridGap: '24px',
    gridAutoFlow: 'row',
    gridAutosummaryRows: 'max-content',
  },
  footer: {
    margin: theme.spacing(1),
  },
  copyClipboard: {
    '& .copy': {
      color: theme.components.typography.passive,
    },
  },
}))

export default CustomResourceDefinitionsOverview
